/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import { Formik, Field } from 'formik';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
// import { Link } from 'react-router-dom';
import {
  Button,
  Box,
  CircularProgress,
  Grid,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  IconButton,
  InputAdornment,
  TextField,
  Autocomplete,
  Checkbox,
  FormControlLabel
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import dateFormat from 'dateformat';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Cards from 'react-credit-cards-2';
import 'react-credit-cards-2/dist/es/styles-compiled.css';
import PaymentAction from '../../../store/actions/PaymentAction';
import globalAction from '../../../store/actions/GlobalAction';
import CVVNumberField from '../../../components/CvvInput';
import { ValidateAuthorize } from '../../../assets/validation';
import PaymentLoader from '../../../utils/errorPages/PaymentLoader';
// import ExpirationDateInput from '../../../components/ExpirationDateInput';
import CardImage from '../../../assets/images/card.png';
import {
  formatCreditCardNumber,
  formatCVC
  // formatExpirationDate
  // formatFormData
} from '../../../utils/CreditCardConfig';

// import PaymentForm from './Card';

function PaymentAuthorizeNet({ clientinfo, code }) {
  const [startDate, setStartDate] = useState(null);
  const navigate = useNavigate();
  const [checked, setChecked] = React.useState(false);
  const [card, setCard] = useState({
    cvc: '',
    expiry: '',
    focus: '',
    card_holder_name: '',
    card_number: '',
    issuer: ''
  });

  const handleSameAddress = (event, setFieldValue) => {
    if (event.target.checked) {
      setChecked(true);
      // Use clientinfo for address fields
      setFieldValue('address_1', clientinfo?.address_1 || '');
      setFieldValue('address_2', clientinfo?.address_2 || '');
      setFieldValue('city', clientinfo?.city || '');
      setFieldValue('zip_code', clientinfo?.postal_code || '');
      setFieldValue('country', clientinfo?.country || '');
      setFieldValue('state', clientinfo?.state || '');
      // Add more fields if needed
    } else {
      setChecked(false);
      // Clear address fields
      setFieldValue('address_1', '');
      setFieldValue('address_2', '');
      setFieldValue('city', '');
      setFieldValue('zip_code', '');
      setFieldValue('country', '');
      setFieldValue('state', '');
      // Clear more fields if needed
    }
  };
  const { countryData, stateData, isLoading } = useSelector((state) => state.global);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(globalAction.getCountryStatus());
  }, [dispatch]);

  const handleCountryChange = (countryId) => {
    dispatch(globalAction.getStateStatus(countryId));
  };

  const handleCallback = ({ issuer }, isValid) => {
    if (isValid) {
      setCard({ ...card, issuer });
    }
  };

  const handleInputFocus = (e) => {
    setCard((prev) => ({ ...prev, focus: e.target.name }));
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'card_number') {
      e.target.value = formatCreditCardNumber(value);
    } else if (name === 'cvc') {
      e.target.value = formatCVC(value);
    }
    setCard({ ...card, [name]: value });
  };

  const handleDateInputChange = (date) => {
    setCard({ ...card, expiry: date });
  };

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper requestType">
      <Formik
        initialValues={{
          card_holder_name: '',
          card_number: '',
          cvc: '',
          expiry: '',
          expire_month: '',
          expire_year: '',
          address_1: '',
          address_2: '',
          country: null,
          state: null,
          city: '',
          zip_code: ''
        }}
        enableReinitialize
        validationSchema={ValidateAuthorize}
        onSubmit={(values, { setErrors, setSubmitting }) => {
          const { expiry, ...newValuesWithoutExpire } = values;
          const stringWithoutSpaces = values.card_number.replace(/\s/g, ''); // Removes all spaces
          const number = parseInt(stringWithoutSpaces, 10); // Converts string to number
          const [month, year] = expiry.split('/');
          const newValues = {
            ...newValuesWithoutExpire,
            card_number: number,
            expire_month: month,
            expire_year: year,
            country: values.country.name,
            state: values.state.name
          };
          dispatch(
            PaymentAction.updateAuthorizeNet(code, newValues, setErrors, setSubmitting, navigate)
          );
        }}
      >
        {({
          errors,
          touched,
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          // handleReset,
          isSubmitting,
          setFieldValue
        }) => (
          <form onSubmit={handleSubmit}>
            {isSubmitting ? <PaymentLoader /> : ''}
            <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
              <Grid item lg={6} xl={6}>
                <Card sx={{ mt: 2 }}>
                  <CardHeader
                    sx={{ textAlign: 'left !important' }}
                    title="Credit Card Details"
                    action={<img src={CardImage} alt="Credit Card" />}
                  />
                  <CardContent>
                    <Box sx={{ mb: 2 }}>
                      <Cards
                        cvc={card.cvc}
                        expiry={card.expiry}
                        focused={card.focus}
                        name={card.card_holder_name}
                        number={card.card_number}
                        callback={handleCallback}
                      />
                    </Box>
                    <Field name="card_holder_name">
                      {({ field }) => (
                        <TextField
                          {...field}
                          label="Cardholder Name"
                          fullWidth
                          margin="normal"
                          variant="outlined"
                          onFocus={handleInputFocus}
                          required={false}
                          InputLabelProps={{ required: true }}
                          onChange={(event) => {
                            field.onChange(event);
                            handleInputChange(event);
                          }}
                          error={touched.card_holder_name && Boolean(errors.card_holder_name)}
                          helperText={touched.card_holder_name && errors.card_holder_name}
                        />
                      )}
                    </Field>
                    <Field name="card_number">
                      {({ field }) => (
                        <TextField
                          {...field}
                          label="Card Number"
                          fullWidth
                          type="tel"
                          margin="normal"
                          variant="outlined"
                          required={false}
                          onFocus={handleInputFocus}
                          InputLabelProps={{ required: true }}
                          onChange={(event) => {
                            handleInputChange(event);
                            field.onChange(event);
                            // setFieldValue('card_number', event.target.value.replace(/\s/g, ' '));
                          }}
                          error={touched.card_number && Boolean(errors.card_number)}
                          helperText={touched.card_number && errors.card_number}
                          InputProps={{
                            pattern: '[\\d| ]{16}',
                            // inputComponent: CreditCardNumberField,
                            endAdornment: (
                              <InputAdornment position="start">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  edge="end"
                                  disabled
                                  // color="secondary"
                                >
                                  <CreditCardIcon sx={{ color: '#fff' }} />
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                        />
                      )}
                    </Field>
                    <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                      <Grid item lg={6} xl={6}>
                        <Field name="cvc">
                          {({ field }) => (
                            <TextField
                              {...field}
                              type="tel"
                              label="CVC Number"
                              fullWidth
                              margin="normal"
                              variant="outlined"
                              required={false}
                              InputLabelProps={{ required: true }}
                              InputProps={{
                                inputComponent: CVVNumberField
                              }}
                              onChange={(event) => {
                                field.onChange(event);
                                handleInputChange(event);
                                // setFieldValue('cvc', event.target.value.replace(/\s/g, ' '));
                              }}
                              onFocus={handleInputFocus}
                              error={touched.cvc && Boolean(errors.cvc)}
                              helperText={touched.cvc && errors.cvc}
                            />
                          )}
                        </Field>
                      </Grid>
                      <Grid item lg={6} xl={6}>
                        <Box className="datepicker">
                          <DatePicker
                            selected={startDate}
                            // onChange={(date) => setStartDate(date)}
                            onChange={(date) => {
                              setStartDate(date);
                              const monthYear = dateFormat(date, 'mm/yyyy');
                              handleDateInputChange(monthYear);
                              setFieldValue('expiry', monthYear);
                            }}
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                            showFullMonthYearPicker
                            minDate={new Date()}
                            name="expiry" // Adding the name attribute here
                            // isClearable
                            customInput={
                              <TextField
                                label="MM/YY"
                                error={touched.expiry && Boolean(errors.expiry)}
                                helperText={touched.expiry && errors.expiry}
                                fullWidth
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                  endAdornment: (
                                    <InputAdornment position="start">
                                      <IconButton
                                        aria-label="toggle password visibility"
                                        edge="end"
                                        disabled
                                        // color="secondary"
                                      >
                                        <CalendarMonthIcon sx={{ color: '#fff' }} />
                                      </IconButton>
                                    </InputAdornment>
                                  )
                                }}
                              />
                            }
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item lg={6} xl={6}>
                <Card sx={{ mt: 2 }}>
                  <CardHeader
                    sx={{ textAlign: 'left !important' }}
                    title="Cardholder Address"
                    action={
                      <FormControlLabel
                        label="Same as Client Address"
                        control={
                          <Checkbox
                            checked={checked}
                            onChange={(event) => {
                              handleSameAddress(event, setFieldValue);
                            }}
                            inputProps={{ 'aria-label': 'controlled' }}
                          />
                        }
                      />
                    }
                  />
                  <CardContent>
                    <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                      <Grid item lg={6} xl={6}>
                        <TextField
                          error={errors.address_1 && touched.address_1}
                          label="Address Line 1"
                          className=""
                          fullWidth
                          name="address_1"
                          value={values.address_1}
                          // maxRows={4}
                          placeholder="Enter Address Line 1"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          helperText={errors.address_1 && touched.address_1 && errors.address_1}
                          margin="normal"
                          variant="outlined"
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item lg={6} xl={6}>
                        <TextField
                          error={errors.address_2 && touched.address_2}
                          label="Address Line 2"
                          className=""
                          fullWidth
                          name="address_2"
                          // maxRows={4}
                          placeholder="Enter Address Line 1"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          helperText={errors.address_2 && touched.address_2 && errors.address_2}
                          margin="normal"
                          variant="outlined"
                          // required={false}
                          // InputLabelProps={{ required: true }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                      <Grid item lg={6} xl={6}>
                        <Field
                          name="country"
                          component={Autocomplete}
                          className="CurrencyField"
                          options={countryData ?? []}
                          // disableClearable
                          onChange={(e, newvalue) => {
                            setFieldValue('country', newvalue);
                            if (newvalue && newvalue._id) {
                              handleCountryChange(newvalue._id);
                            }
                          }}
                          loading={isLoading}
                          value={values.country}
                          getOptionLabel={(option) => (option ? option.name : '')}
                          isOptionEqualToValue={(option, value) => option.name === value.name}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option.name}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="country"
                              error={touched.country && !!errors.country}
                              helperText={touched.country && errors.country}
                              label="Select Country"
                              placeholder="Search Country"
                              variant="outlined"
                              margin="normal"
                              required={false}
                              InputLabelProps={{ required: true }}
                              // SelectProps={{
                              //   IconComponent: ExpandMore
                              // }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item lg={6} xl={6}>
                        <Field
                          name="state"
                          component={Autocomplete}
                          className="CurrencyField"
                          isOptionEqualToValue={(option, value) => option.name === value.name}
                          value={values.state}
                          options={stateData ?? []}
                          // disableClearable
                          onChange={(e, newvalue) => {
                            setFieldValue('state', newvalue);
                          }}
                          loading={isLoading}
                          getOptionLabel={(option) => (option ? option.name : '')}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option.name}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="state"
                              error={touched.state && !!errors.state}
                              helperText={touched.state && errors.state}
                              label="Select State"
                              placeholder="Search State"
                              variant="outlined"
                              margin="normal"
                              required={false}
                              InputLabelProps={{ required: true }}
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                    <Grid container columnSpacing={2} rowSpacing={0} alignItems="stretch">
                      <Grid item lg={6} xl={6}>
                        <TextField
                          error={errors.city && touched.city}
                          label="City"
                          className=""
                          fullWidth
                          name="city"
                          value={values.city}
                          // maxRows={4}
                          placeholder="Enter City"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          helperText={errors.city && touched.city && errors.city}
                          margin="normal"
                          variant="outlined"
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item lg={6} xl={6}>
                        <Box className="datepicker">
                          <TextField
                            error={errors.zip_code && touched.zip_code}
                            label="Postal Code"
                            className=""
                            fullWidth
                            name="zip_code"
                            value={values.zip_code}
                            // maxRows={4}
                            placeholder="Enter Postal Code"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            helperText={errors.zip_code && touched.zip_code && errors.zip_code}
                            margin="normal"
                            variant="outlined"
                            required={false}
                            InputLabelProps={{ required: true }}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                    {/* <PaymentForm /> */}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            <Card sx={{ mt: 2 }}>
              <CardActions sx={{ justifyContent: 'center', py: '20px!important' }}>
                <Button
                  type="submit"
                  className="save__btn"
                  variant="contained"
                  color="secondary"
                  // fullWidth
                  disabled={isSubmitting}
                  size="large"
                >
                  {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                </Button>
              </CardActions>
            </Card>
          </form>
        )}
      </Formik>
    </Box>
  );
}

PaymentAuthorizeNet.propTypes = {
  code: PropTypes.string.isRequired,
  clientinfo: PropTypes.func.isRequired
};

export default PaymentAuthorizeNet;
